import { HelpPanel } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../../../hooks/localizedText';

export function ShiftTypeInfoHelpPanel() {
  const { t } = useLocalizedText(['events']);
  return (
    <HelpPanel header={<h2>{t('shiftStep.shiftTypeInfoHeader')}</h2>}>
      <h3>{t('shiftStep.scheduledShift')}</h3>
      <p>{t('shiftStep.shiftTypeInfoScheduledDescription')}</p>
      <p>{t('shiftStep.shiftTypeInfoScheduledExample')}</p>
      <h3>{t('shiftStep.flexibleShift')}</h3>
      <p>{t('shiftStep.shiftTypeInfoFlexibleDescription')}</p>
      <p>{t('shiftStep.shiftTypeInfoFlexibleExampleNoTimes')}</p>
      <p>{t('shiftStep.shiftTypeInfoFlexibleExampleWithTimes')}</p>
    </HelpPanel>
  );
}
